import {
    getData,
    postData,
  } from "../../api";

export const GetAddress = async (user_id) => {
    try {
      const res = await getData(
        `/getaddress`
      );
  
      return res;
    } catch (error) {
      console.log(error);
    }
  };